var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "#84BD00",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.125 6.89844C12.125 6.6875 12.2656 6.5 12.5 6.5C15.3828 6.5 17.75 8.86719 17.75 11.75C17.75 11.9609 17.5625 12.125 17.3516 12.125H12.125V6.89844ZM5.75 12.875C5.75 10.0391 7.85938 7.69531 10.5781 7.32031C10.8125 7.27344 11 7.46094 11 7.67188V13.25L14.6562 16.9297C14.8203 17.0938 14.7969 17.3516 14.6328 17.4688C13.6953 18.125 12.5703 18.5 11.375 18.5C8.25781 18.5 5.75 15.9922 5.75 12.875ZM18.0781 13.25C18.2891 13.25 18.4766 13.4375 18.4297 13.6484C18.2656 14.9609 17.6328 16.1328 16.6953 17C16.5547 17.1172 16.3438 17.1172 16.2031 16.9766L12.5 13.25H18.0781Z",
    fill: "#84BD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.cacba9a7b2bfd29d81373d09dc220f12.svg";
export { ForwardRef as ReactComponent };